export const arrayPrototype = Array.prototype
export const mapPrototype = Map.prototype
export const objectPrototype = Object.prototype
export const setPrototype = Set.prototype
export const weakMapPrototype = WeakMap.prototype
export const weakSetPrototype = WeakSet.prototype
export const assign = Object.assign
export const defineProperty = Object.defineProperty
export const freeze = Object.freeze
export const fromEntries = Object.fromEntries
export const getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor
export const getOwnPropertyDescriptors = Object.getOwnPropertyDescriptors
export const getPrototypeOf = Object.getPrototypeOf
export const isArray = Array.isArray
export const toString = Object.prototype.toString
